import { render, staticRenderFns } from "./HospitalIntroDoucan.vue?vue&type=template&id=0a2fe043&scoped=true"
import script from "./HospitalIntroDoucan.vue?vue&type=script&lang=js"
export * from "./HospitalIntroDoucan.vue?vue&type=script&lang=js"
import style0 from "./HospitalIntroDoucan.vue?vue&type=style&index=0&id=0a2fe043&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a2fe043",
  null
  
)

export default component.exports